module.exports = __webpack_public_path__ + "static/media/rainbowsix.64850aed.jpg";